const str = `{HEADER}คำชี้แจงสิทธิ์ส่วนบุคคล
{HEADER_SUB}Video Monster Co. , Ltd. (ต่อไปเรียกว่า 'บริษัท ') ปฏิบัติตามกฎหมายและข้อบังคับทั้งหมดที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคลรวมถึง 'พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล' และ 'พระราชบัญญัติส่งเสริมการใช้เครือข่ายสารสนเทศและการสื่อสารและ  การคุ้มครองข้อมูล ฯลฯ 'และการประมวลผลข้อมูลส่วนบุคคลของบริษัทด้วยการกำหนดนโยบายแยกต่างหากและปฏิบัติตามนโยบายนี้เราพยายามอย่างเต็มที่เพื่อปกป้องข้อมูลส่วนบุคคลของผู้ใช้.

{BODY_TITLE}ข้อ 1 (กฎทั่วไป)
1) 'ข้อมูลส่วนบุคคล' คือข้อมูลเกี่ยวกับบุคคลที่ยังมีชีวิตอยู่ข้อมูลที่สามารถระบุตัวบุคคลตามชื่อ (ชื่อเล่น) และที่อยู่อีเมลที่รวมอยู่ในข้อมูล (ข้อมูลเพียงอย่างเดียวสามารถระบุตัวบุคคลที่เฉพาะเจาะจงได้) รวมถึงสิ่งที่สามารถรวมและระบุกับข้อมูลอื่น ๆ ได้อย่างง่ายดายแม้ว่าจะไม่มีอยู่ก็ตาม).
2) บริษัท กำลังดำเนินมาตรการเพื่อให้สมาชิกสามารถเข้าถึงได้ง่ายโดยการเปิดเผยนโยบายการจัดการข้อมูลส่วนบุคคลในหน้าแรกและแอปพลิเคชัน.
3) บริษัท ได้กำหนดขั้นตอนที่จำเป็นเพื่อแก้ไขนโยบายการจัดการข้อมูลส่วนบุคคลเพื่อปรับปรุงนโยบายการจัดการข้อมูลส่วนบุคคลอย่างต่อเนื่องและเมื่อแก้ไขนโยบายการจัดการข้อมูลส่วนบุคคลจะมีการให้หมายเลขเวอร์ชัน ฯลฯ เพื่อให้สมาชิกสามารถระบุได้ง่าย  เรื่องแก้ไขที่กำลังทำอยู่.

{BODY_TITLE}ข้อ 2 (รายการข้อมูลส่วนบุคคลและวิธีการรวบรวม)
1) บริษัท รวบรวมข้อมูลส่วนบุคคลต่อไปนี้สำหรับการลงทะเบียนสมาชิกการให้คำปรึกษาลูกค้าที่ราบรื่นและบริการชำระเงิน  สมาชิกที่มีอายุต่ำกว่า 14 ปีถูกจำกัด ไม่ให้สมัครสมาชิกและใช้บริการ
2) ข้อมูลที่ให้กับสื่อ (โปรไฟล์สาธารณะที่อยู่อีเมลวันเกิดภาพถ่ายและวิดีโอ ฯลฯ ) อาจถูกรวบรวมเมื่อสมัครและเข้าสู่ระบบในฐานะสมาชิกของ Naver, Google หรือ Facebook
3) รายการข้อมูลส่วนบุคคลที่จะรวบรวม
① ช่องที่ต้องกรอก
- ชื่อ (ชื่อเล่น) รหัสสมาชิก (เช่นเดียวกับที่อยู่อีเมล) รหัสผ่านแม้ว่าอายุ 14 ปีหรือมากกว่าขึ้นไป
②รายการอินพุตเสริม
- เพศกลุ่มอายุที่อยู่ประเภทงานวัตถุประสงค์การใช้งานข้อมูลติดต่อผู้แนะนำหมายเลขโทรศัพท์
③ข้อมูลที่สามารถรวบรวมได้ระหว่างการใช้บริการแบบชำระเงินใช้เฉพาะในขั้นตอนการชำระเงินและ. ไม่มีการบันทึกใด ๆ ในบริษัท
- ส่วนกลาง : ชื่อเต็ม (ชื่อจริง) หมายเลขโทรศัพท์มือถือ
- เมื่อชำระเงินด้วยบัตรเครดิต: ชื่อบัตรหมายเลขบัตรวันหมดอายุของบัตร
- เมื่อชำระเงินด้วยโทรศัพท์มือถือ:หมายเลขโทรศัพท์มือถือผู้ให้บริการวันเดือนปีเกิดหมายเลขอนุมัติการชำระเงิน ฯลฯ
- สำหรับการชำระเงินด้วยการโอนบัญชี: ชื่อธนาคารเลขที่บัญชี ฯลฯ
- เมื่อชำระค่าบัตรของขวัญ: หมายเลขบัตรของขวัญ
④ข้อมูลต่อไปนี้อาจถูกสร้างและรวบรวมโดยอัตโนมัติในระหว่างขั้นตอนการใช้บริการหรือ. กระบวนการประมวลผลทางธุรกิจ
- บันทึกการใช้บริการบันทึกการเข้าถึงคุกกี้เข้าถึงข้อมูล IP บันทึกการชำระเงินบันทึกการระงับการ   ใช้งาน ฯลฯ
4) วิธีการรวบรวม
①การลงทะเบียนสมาชิกผ่านทางโฮมเพจแบบฟอร์มแฟกซ์,หรืออีเมล
②โทรศัพท์, กระดานข่าวให้คำปรึกษา, แอปพลิเคชันกิจกรรม, คำขอจัดส่ง

{BODY_TITLE}ข้อ 3 (ยินยอมให้รวบรวมข้อมูลส่วนบุคคล)
1) บริษัท	สร้างสภาพแวดล้อมที่สมาชิกสามารถสมัครสมาชิกหลังจากทำเครื่องหมายเพื่อให้พวกเขาสามารถตรวจสอบนโยบายการจัดการข้อมูลส่วนบุคคลของ บริษัท ได้
2) บริษัท	แจ้งและได้รับความยินยอมเกี่ยวกับข้อมูลส่วนบุคคลที่รวบรวมและวัตถุประสงค์ในการใช้งานตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของสมาชิกที่รวบรวมเมื่อลงทะเบียนเป็นสมาชิก

{BODY_TITLE}ข้อ 4 (วัตถุประสงค์ในการรวบรวมและใช้ข้อมูลส่วนบุคคล)
บริษัท รวบรวมข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้และวัตถุประสงค์เฉพาะในการรวบรวมและใช้ตามรายการข้อมูลส่วนบุคคลที่จะรวบรวมมีดังต่อไปนี้
1) ข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการจัดการสมาชิก
①ช่องที่ต้องกรอก
- ชื่อ (ชื่อเล่น) รหัสสมาชิก (เช่นเดียวกับที่อยู่อีเมล) รหัสผ่าน: ใช้สำหรับขั้นตอนการระบุตัวตนที่จำเป็นสำหรับการใช้บริการ
- ไม่ว่าจะอายุต่ำกว่า 14 ปี: จำเป็นต้อง จำกัด การลงทะเบียนสมาชิกและการใช้บริการสำหรับเด็กอายุต่ำกว่า 14 ปี
- รหัสสมาชิก (เช่นเดียวกับที่อยู่อีเมล): การส่งหนังสือแจ้งยืนยันความตั้งใจของบุคคลการรักษาเส้นทางการสื่อสารที่ราบรื่นเช่นการจัดการข้อร้องเรียนและการให้ข้อมูลเกี่ยวกับบริการและเหตุการณ์ใหม่ ๆ
- รับอีเมล (จดหมายข่าวรายละเอียดการชำระเงิน) หรือไม่: ตรวจสอบว่าจะได้รับอีเมลเช่นข้อมูลอัปเดตข่าวกิจกรรมรายละเอียดการชำระเงิน ฯลฯ
②รายการอินพุตเสริม
- เพศอาชีพวัตถุประสงค์ในการใช้งานข้อมูลติดต่อผู้แนะนำหมายเลขโทรศัพท์: การรักษาความปลอดภัยข้อมูลเพื่ออ้างอิงสำหรับทิศทางการพัฒนาของ บริษัท
- ข้อมูลการติดต่อและที่อยู่: การยืนยันความเหมาะสมของผู้เข้าร่วมเมื่อจัดกิจกรรมและรางวัลและการระบุที่อยู่จัดส่งที่ถูกต้องสำหรับการจัดส่ง
2) บริษัท ไม่รวบรวมข้อมูลส่วนบุคคลที่ละเอียดอ่อน (เชื้อชาติและชาติพันธุ์อุดมการณ์และความเชื่อสถานที่กำเนิดและภูมิลำเนาแนวทางการเมืองและประวัติอาชญากรรม,สถานะสุขภาพและชีวิตทางเพศ ฯลฯ ) ที่อาจละเมิดสิทธิมนุษยชนขั้นพื้นฐานของผู้ใช้

{BODY_TITLE}ข้อ 5 (การติดตั้ง / การใช้งานและการปฏิเสธอุปกรณ์รวบรวมข้อมูลส่วนบุคคลอัตโนมัติ)
บริษัทใช้คุกกี้เพื่อจัดเก็บและค้นหาข้อมูลของสมาชิกเป็นครั้งคราว คุกกี้คือไฟล์ข้อความที่มีขนาดน้อยกว่า 4KB ซึ่งจะถูกถ่ายโอนไปยังคอมพิวเตอร์ของลูกค้าโดยอัตโนมัติเมื่อเข้าถึง Video Monster และถูกเก็บไว้ในฮาร์ดดิสก์ของสมาชิก
1) วัตถุประสงค์ในการใช้คุกกี้
ใช้เพื่อให้ข้อมูลที่ปรับแต่งได้อย่างเหมาะสมรวมถึงการเยี่ยมชมและการใช้งานของสมาชิกการเข้าถึงที่ปลอดภัยและโฆษณา
2) การติดตั้ง / การใช้งานและการปฏิเสธคุกกี้
①คุณมีสิทธิ์เลือกคุกกี้  ดังนั้นด้วยการตั้งค่าตัวเลือกของเว็บเบราว์เซอร์ที่คุณใช้คุณสามารถอนุญาตคุกกี้ทั้งหมดตรวจสอบทุกครั้งที่บันทึกคุกกี้หรือปฏิเสธที่จะบันทึกคุกกี้ทั้งหมด
②ตัวอย่างวิธีการตั้งค่า (Google Chrome)
ด้านบนขวาเพิ่มเติม> การตั้งค่า> ความเป็นส่วนตัวและความปลอดภัย> คุกกี้และข้อมูลอื่น ๆ ของไซต์
หากคุณปฏิเสธที่จะเก็บคุกกี้อาจมีปัญหาในการใช้บริการ

{BODY_TITLE}ข้อ 6 (การใช้งานและการจัดเตรียมและการแบ่งปันที่ไม่ได้มีวัตถุประสงค์เพื่อให้บุคคลที่สาม)
1) บริษัทใช้ข้อมูลส่วนบุคคลของคุณภายในขอบเขตที่แจ้งไว้ใน「วัตถุประสงค์ในการรวบรวมและใช้ข้อมูลส่วนบุคคล」และไม่ใช้ข้อมูลเกินขอบเขตหรือเปิดเผยต่อบุคคลอื่น บริษัท อื่นองค์กร ฯลฯ
2) กรณีต่อไปนี้เป็นข้อยกเว้น
①เมื่อมีการร้องขอจากหน่วยงานที่เกี่ยวข้องเพื่อวัตถุประสงค์ในการตรวจสอบตามกฎหมายและระเบียบที่เกี่ยวข้อง
②ในกรณีของการจัดหาให้กับผู้โฆษณาพันธมิตรหรือองค์กรวิจัยในรูปแบบที่ไม่สามารถระบุบุคคลที่เฉพาะเจาะจงสำหรับการเขียนเชิงสถิติการวิจัยทางวิชาการหรือการวิจัยตลาด
③เมื่อมีการร้องขอตามขั้นตอนที่กำหนดไว้ในกฎหมายและข้อบังคับอื่น ๆ ที่เกี่ยวข้อง
④แม้ว่าข้อมูลจะได้รับการจัดเตรียมตามกฎหมายที่เกี่ยวข้องหรือตามคำร้องขอของหน่วยงานสืบสวนในกรณีพิเศษ แต่ก็มีการดำเนินการตามหลักการเพื่อแจ้งให้คู่กรณีทราบ  อาจมีบางกรณีที่อาจไม่มีการแจ้งเตือนโดยหลีกเลี่ยงไม่ได้เนื่องจากเหตุผลทางกฎหมาย
3) เราจะพยายามอย่างดีที่สุดเพื่อป้องกันไม่ให้มีการให้ข้อมูลที่ขัดกับวัตถุประสงค์ดั้งเดิมของการรวบรวมและการใช้งานโดยเด็ดขาด

{BODY_TITLE}ข้อ 7 (การส่งมอบการจัดการข้อมูลส่วนบุคคล)
1)บริษัทส่งมอบข้อมูลส่วนบุคคลดังต่อไปนี้เพื่อปรับปรุงการบริการและกำหนดเรื่องที่จำเป็นเพื่อให้สามารถจัดการข้อมูลส่วนบุคคลได้อย่างปลอดภัยเมื่อส่งมอบสัญญาตามกฎหมายและข้อบังคับที่เกี่ยวข้อง
2) หน่วยงานประมวลผลการฝากขายข้อมูลส่วนบุคคลของ บริษัท และเนื้อหาของงานฝากขายมีดังต่อไปนี้
- ผู้ดูแล: Google
- รายละเอียดการฝากขาย:วิเคราะห์ข้อมูลการใช้งาน (Google Analytics) และการจัดเก็บข้อมูล (Google Cloud Platform)
{ADD_LINE}
- ผู้ดูแล: Microsoft Azure
- รายละเอียดการฝากขาย: การจัดเก็บข้อมูล (Microsoft Cloud Services)
{ADD_LINE}
- ผู้ดูแล: MailChimp
- รายละเอียดการฝากขาย: การสนับสนุนการสื่อสารทางอีเมล
{ADD_LINE}
- ผู้ดูแล: เฟสบุ๊ค
- รายละเอียดการฝากขาย: การสนับสนุนประสบการณ์ลูกค้าส่วนบุคคล
{ADD_LINE}
- ผู้ดูแล: Salesforce
- รายละเอียดการฝากขาย: การจัดเก็บข้อมูลการสนับสนุนการให้คำปรึกษาลูกค้า
{ADD_LINE}
- ผู้ดูแล: INICIS
- รายละเอียดการฝากขาย: หน่วยงานการชำระเงิน
{ADD_LINE}
- ผู้ดูแล: Zencoder
- รายละเอียดการฝากขาย: แปลงไฟล์วิดีโอที่อัปโหลดโดยผู้ใช้

{BODY_TITLE}ข้อ 8 (สิทธิ์ของผู้ใช้และตัวแทนทางกฎหมายและวิธีการใช้สิทธิ)
1)สมาชิกสามารถใช้สิทธิ์ต่อไปนี้ที่เกี่ยวข้องกับการปกป้องข้อมูลส่วนบุคคลได้ตลอดเวลาที่เกี่ยวข้องกับ บริษัท
①ขอดูข้อมูลส่วนบุคคล
②ขอแก้ไขหากมีข้อผิดพลาด
③ขอให้ลบ
④ขอให้หยุดดำเนินการ
2) ในการใช้สิทธิ์ตามวรรค 1 หลังจากเข้าสู่หน้าแรกดูแก้ไขหรือขอถอนจากวิดีโอของฉันโดยตรง> การตั้งค่าบัญชีที่ด้านบนขวาของเว็บไซต์ไปที่ผู้ใช้เองหรือเขียนถึงบุคคลนั้นรับผิดชอบการจัดการข้อมูลส่วนบุคคลและบุคคลที่รับผิดชอบทางโทรศัพท์หรืออีเมลหากคุณติดต่อเราทางไปรษณีย์หรือแฟกซ์เราจะดำเนินการโดยไม่ชักช้าหลังจากยืนยันตัวตนของคุณ
3) หากสมาชิกร้องขอการแก้ไขหรือลบข้อผิดพลาดในข้อมูลส่วนบุคคล บริษัท จะไม่ใช้หรือให้ข้อมูลส่วนบุคคลจนกว่าการแก้ไขหรือลบจะเสร็จสิ้น

{BODY_TITLE}ข้อ 9 (การทำลายข้อมูลส่วนบุคคลและการจัดเก็บแยกต่างหาก)
โดยหลักการแล้วข้อมูลส่วนบุคคลของสมาชิกจะถูกทำลายโดยไม่ชักช้าเมื่อบรรลุวัตถุประสงค์ในการรวบรวมและใช้ข้อมูลส่วนบุคคล  ขั้นตอนและวิธีการทำลายข้อมูลส่วนบุคคลของ บริษัท มีดังต่อไปนี้
1) ขั้นตอนการทำลายล้าง
① ข้อมูลที่ผู้ใช้ป้อนสำหรับการลงทะเบียนสมาชิก ฯลฯ จะถูกโอนไปยังฐานข้อมูลแยกต่างหาก (เอกสารแยกต่างหากในกรณีของกระดาษ) หลังจากบรรลุวัตถุประสงค์และตามเหตุผลในการปกป้องข้อมูลตามนโยบายภายในและกฎหมายอื่น ๆ ที่เกี่ยวข้อง  (อ้างถึงการเก็บรักษาและระยะเวลาการใช้งาน)  มันถูกทำลายหลังจากถูกเก็บไว้ในช่วงเวลาหนึ่ง
② ข้อมูลส่วนบุคคลที่ถ่ายโอนไปยังฐานข้อมูลแยกต่างหากจะไม่ถูกใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากการเก็บรักษาเว้นแต่กฎหมายกำหนด
2) วิธีการทำลายล้าง
①ข้อมูลส่วนบุคคลที่จัดเก็บเป็นไฟล์อิเล็กทรอนิกส์จะถูกลบโดยใช้วิธีการทางเทคนิคที่ไม่สามารถทำซ้ำบันทึกได้
②ข้อมูลส่วนบุคคลที่พิมพ์บนกระดาษถูกทำลายโดยการหั่นย่อยสลายหรือเผาทำลายทิ้ง
3) การจัดเก็บแยกต่างหาก
①ข้อมูลส่วนบุคคลของสมาชิก (ไม่ใช่ผู้ใช้งานระยะยาว) ที่ไม่ได้ใช้บริการ Video Monster เป็นเวลาหนึ่งปีติดต่อกันจะถูกจัดเก็บแยกกัน
②ข้อมูลสมาชิกที่จัดเก็บแยกกันจะถูกแปลงเป็นบัญชีเฉยๆและหากคุณเข้าสู่ระบบหลังจากเปลี่ยนไปใช้บัญชีที่ไม่อยู่เฉยๆบัญชีที่อยู่เฉยๆจะถูกยกเลิก
③ข้อมูลสมาชิกที่จัดเก็บแยกกันจะถูกทำลายหลังจากช่วงเวลาหนึ่งตามกฎหมายและข้อบังคับที่เกี่ยวข้อง

{BODY_TITLE}ข้อ 10 (ระยะเวลาการเก็บรักษาและการใช้ข้อมูลส่วนบุคคล)
โดยหลักการแล้วข้อมูลส่วนบุคคลของสมาชิกจะถูกทำลายเมื่อบรรลุวัตถุประสงค์ในการรวบรวมหรือรับข้อมูลส่วนบุคคล  อย่างไรก็ตามข้อมูลต่อไปนี้จะถูกเก็บรักษาไว้ตามระยะเวลาที่กำหนดด้วยเหตุผลดังต่อไปนี้
1) เหตุผลในการเก็บรักษาข้อมูลตามนโยบายภายในของ บริษัท
①บันทึกผู้ใช้ที่ฉ้อโกง
- เหตุผลในการเก็บรักษา: การป้องกันการลงทะเบียนซ้ำของผู้ใช้ที่ไม่ดีข้อพิพาทเกี่ยวกับการละเมิดสิทธิ์เช่นการหมิ่นประมาทและความร่วมมือในการสอบสวน
- ระยะเวลาเก็บรักษา: 1 ปี
{ADD_LINE}
2) เหตุผลในการเก็บรักษาข้อมูลตามกฎหมายที่เกี่ยวข้อง
①บันทึกเกี่ยวกับสัญญาหรือการถอนการสมัครสมาชิก ฯลฯ
- เหตุผลในการเก็บรักษา: พระราชบัญญัติคุ้มครองผู้บริโภคในธุรกรรมพาณิชย์อิเล็กทรอนิกส์ ฯลฯ
- ระยะเวลาเก็บรักษา: 5 ปี
{ADD_LINE}
②บันทึกการชำระเงินและการจัดหาสินค้า ฯลฯ
- เหตุผลในการเก็บรักษา: พระราชบัญญัติคุ้มครองผู้บริโภคในธุรกรรมพาณิชย์อิเล็กทรอนิกส์ ฯลฯ
- ระยะเวลาเก็บรักษา: 5 ปี
{ADD_LINE}
③บันทึกข้อร้องเรียนของผู้บริโภคหรือการระงับข้อพิพาท
- เหตุผลในการเก็บรักษา: พระราชบัญญัติคุ้มครองผู้บริโภคในอีคอมเมิร์ซ ฯลฯ
- ระยะเวลาเก็บรักษา: 3 ปี
{ADD_LINE}
④บันทึกการเยี่ยมชม
- เหตุผลในการเก็บรักษา: พระราชบัญญัติคุ้มครองความลับในการสื่อสาร
- ระยะเวลาเก็บรักษา: 3 เดือน

{BODY_TITLE}ข้อ 11 (มาตรการทางเทคนิคและการบริหารสำหรับข้อมูลส่วนบุคคล)
ในการจัดการการปกป้องข้อมูลส่วนบุคคลของสมาชิก บริษัท ใช้มาตรการทางเทคนิคต่อไปนี้เพื่อความปลอดภัยเพื่อไม่ให้ข้อมูลส่วนบุคคลสูญหายถูกขโมยรั่วไหลเปลี่ยนแปลงหรือเสียหาย
1) มาตรการทางเทคนิคเพื่อปกป้องข้อมูลส่วนบุคคล
①ข้อมูลส่วนบุคคลของสมาชิกได้รับการปกป้องด้วยรหัสผ่านรหัสผ่านของ ID ผู้ใช้สามารถทราบได้โดยบุคคลเท่านั้นและการยืนยันและการเปลี่ยนแปลงข้อมูลส่วนบุคคลสามารถทำได้โดยผู้ที่รู้รหัสผ่านเท่านั้น
②ในการเตรียมพร้อมสำหรับการบุกรุกจากภายนอกเช่นการแฮ็กปัจจุบัน บริษัท ใช้อุปกรณ์ที่ปิดกั้นการบุกรุกจากภายนอกเพื่อป้องกันการรั่วไหลของข้อมูลส่วนบุคคลของสมาชิก  โดยเฉพาะอย่างยิ่งเซิร์ฟเวอร์ที่มีข้อมูลส่วนบุคคลของผู้ใช้จะรักษาความปลอดภัยในระดับสูง
③ บริษัท มีระบบสำรองระบบและข้อมูลในกรณีฉุกเฉิน
2) มาตรการดูแลข้อมูลส่วนบุคคล
① บริษัท จำกัด การเข้าถึงข้อมูลส่วนบุคคลของสมาชิกไว้ที่จำนวนคนขั้นต่ำ  ผู้ที่ตกอยู่ภายใต้จำนวนคนขั้นต่ำมีดังนี้
- บุคคลที่ดำเนินธุรกิจการตลาดโดยตรงกับผู้ใช้
- บุคคลที่ปฏิบัติงานด้านการจัดการข้อมูลส่วนบุคคลเช่นผู้รับผิดชอบการจัดการข้อมูลส่วนบุคคลและผู้รับผิดชอบ
- ผู้ที่หลีกเลี่ยงไม่ได้ที่จะจัดการข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางธุรกิจอื่น ๆ
②มีการฝึกอบรมภายในองค์กรและการฝึกอบรมจากภายนอกเป็นประจำแก่พนักงานที่จัดการข้อมูลส่วนบุคคลเกี่ยวกับการได้มาซึ่งเทคโนโลยีความปลอดภัยใหม่ ๆ และภาระหน้าที่ในการปกป้องข้อมูลส่วนบุคคล
③เราได้กำหนดขั้นตอนภายในเพื่อป้องกันการรั่วไหลของข้อมูลโดยบุคคลผ่านคำมั่นสัญญาด้านความปลอดภัยของพนักงานทุกคนเมื่อเข้ามาใน บริษัท และเพื่อตรวจสอบการปฏิบัติตามนโยบายการจัดการข้อมูลส่วนบุคคลและการปฏิบัติตามข้อกำหนดของพนักงาน
④การถ่ายโอนงานของผู้จัดการที่เกี่ยวข้องกับข้อมูลส่วนบุคคลจะดำเนินการอย่างทั่วถึงในขณะที่มีการรักษาความปลอดภัยและมีการชี้แจงความรับผิดชอบต่ออุบัติเหตุข้อมูลส่วนบุคคลหลังจากเข้าและออกจาก บริษัท
⑤ บริษัท จะไม่รับผิดชอบต่อความผิดพลาดใด ๆ ที่เกิดขึ้นโดยผู้ใช้หรือสิ่งที่เกิดขึ้นเนื่องจากความเสี่ยงพื้นฐานทางอินเทอร์เน็ต  เพื่อปกป้องข้อมูลส่วนบุคคลสมาชิกแต่ละคนต้องจัดการ ID และรหัสผ่านของตนอย่างเหมาะสมและรับผิดชอบต่อสิ่งนี้
⑥ในกรณีที่ข้อมูลส่วนบุคคลสูญหายรั่วไหลเปลี่ยนแปลงหรือเสียหายเนื่องจากความผิดพลาดของผู้จัดการภายในหรืออุบัติเหตุด้านการจัดการทางเทคนิค บริษัท จะแจ้งให้สมาชิกทราบทันทีและใช้มาตรการและการชดเชยที่เหมาะสม

{BODY_TITLE}ข้อ 12 (การรั่วไหลไปสู่เว็บไซต์ภายนอก)
1) บริษัท อาจให้สมาชิกเชื่อมโยงไปยังเว็บไซต์หรือเอกสารของบริษัทอื่น ในกรณีนี้บริษัทไม่มีการควบคุมเว็บไซต์ภายนอกใดๆ ดังนั้นจึงไม่สามารถรับผิดชอบต่อประโยชน์ของบริการหรือผลิตภัณฑ์ที่จัดหาให้และไม่สามารถรับประกันได้
2) หากคุณคลิกลิงก์ที่บริษัทรวมไว้ เพื่อย้ายไปยังหน้าของเว็บไซต์อื่นๆ นโยบายความเป็นส่วนตัวของเว็บไซต์นั้นไม่เกี่ยวข้องกับบริษัท ดังนั้นโปรดตรวจสอบนโยบายของเว็บไซต์ที่เพิ่งเข้าเยี่ยมชม

{BODY_TITLE}ข้อ 13 (การส่งข้อมูลการโฆษณา)
1) บริษัทไม่ส่งข้อมูลการโฆษณาเพื่อวัตถุประสงค์ทางการค้า   โดยขัดต่อเจตนาที่ชัดเจนของสมาชิกที่จะปฏิเสธการรับ
2) หากสมาชิกยินยอมให้ส่งอีเมลเช่นจดหมายข่าว บริษัท จะดำเนินมาตรการเพื่อให้สมาชิกสามารถจดจำได้ง่ายในหัวข้อและเนื้อหาของอีเมลดังต่อไปนี้
① หัวเรื่องอีเมล: วลี [การโฆษณา] อาจไม่ปรากฏในบรรทัดหัวเรื่องและเนื้อหาหลัก แต่เนื้อหาอีเมลจะปรากฏขึ้น

{BODY_TITLE}ข้อ 14 (ภาระผูกพันที่จะต้องแจ้งให้ทราบ)
นโยบายการจัดการข้อมูลส่วนบุคคลในปัจจุบันจะได้รับแจ้งผ่านทางหน้าแรกอย่างน้อย 7 วันก่อนการแก้ไขเมื่อมีการเพิ่มเติมลบหรือแก้ไขเนื้อหาตามนโยบายของรัฐบาลหรือการเปลี่ยนแปลงเทคโนโลยีความปลอดภัย

{BODY_TITLE}ข้อ 15 (ผู้รับผิดชอบและผู้รับผิดชอบการจัดการข้อมูลส่วนบุคคล)
บริษัท พยายามอย่างเต็มที่เพื่อให้สมาชิกใช้ข้อมูลที่ดีอย่างปลอดภัย ผู้รับผิดชอบในการจัดการข้อมูลส่วนบุคคลของสมาชิกมีดังต่อไปนี้และเราตอบสนองต่อข้อซักถามที่เกี่ยวข้องกับข้อมูลส่วนบุคคลอย่างรวดเร็วและซื่อสัตย์
ผู้จัดการข้อมูลส่วนบุคคล
- ชื่อ: จอนดงฮยอก
- สังกัด: ทีมปกป้องข้อมูลส่วนบุคคล
- ตำแหน่ง: CEO
- อีเมล: support@videomonster.com
- เบอร์โทรศัพท์: 02-554-6801
{ADD_LINE}
ผู้จัดการข้อมูลส่วนบุคคล
- ชื่อ: อีอูซบ
- สังกัด: ทีมปกป้องข้อมูลส่วนบุคคล
- ตำแหน่ง: ผู้จัดการฝ่ายเทคนิค
- อีเมล: support@videomonster.com
- เบอร์โทรศัพท์: 02-554-6801
{ADD_LINE}
หากคุณต้องการรายงานหรือปรึกษาเกี่ยวกับข้อมูลส่วนบุคคลอื่น ๆ โปรดติดต่อองค์กรต่อไปนี้
ศูนย์รายงานการละเมิดข้อมูลส่วนบุคคล (privacy.kisa.or.kr / 118 ไม่มีรหัสพื้นที่)
กองสืบสวนไซเบอร์ของสำนักงานอัยการสูงสุด (www.spo.go.kr / 1301 ไม่มีรหัสพื้นที่)
สำนักงานตำรวจแห่งชาติ Cyber Security Bureau (www.ctrc.go.kr / 182 ไม่มีรหัสพื้นที่)

{FOOTER}<ข้อมูลเพิ่มเติม>
{FOOTER_SUB}นโยบายนี้จะมีผลบังคับใช้ 1 พฤษภาคม 2021
`

export default str